import { ChargingSessionModel } from '../../charging-sessions'
import { AuthMethod } from '../../charging-sessions/types'

/**
 * Utils function for sorting authentication options
 * First, we compare by cardName first
 * If card from session A has a name but card from sessionB does not, sessionA comes first
 * If card from session B has a name but card from sessionA does not, sessionB comes first
 * Prioritize authentication method. (e.g. RFID comes before OCPP)
 * If both cards are missing a user-selected card name, compare by RFID of the card
 * If sessionA was started using an RFID card but sessionB wasn't, sessionA comes first
 * If sessionB was started using an RFID card but sessionA wasn't, sessionB comes first
 * What is left are non-authenticated sessions, and because we cannot compare them by RFID, nor by card name, so we consider them equal
 */
export const authenticationSortFn = (
  sessionA: Omit<ChargingSessionModel['authentication'], 'tokenType' | 'ocpiTokenId'>,
  sessionB: Omit<ChargingSessionModel['authentication'], 'tokenType' | 'ocpiTokenId'>
): number => {
  const authenticationMethodSortPriority: AuthMethod[] = ['RFID', 'OCPP', 'QR_CODE', 'NONE', ''] as const

  if (sessionA.cardName && sessionB.cardName) {
    return sessionA.cardName.localeCompare(sessionB.cardName)
  }

  if (sessionA.cardName && !sessionB.cardName) {
    return -1
  }

  if (!sessionA.cardName && sessionB.cardName) {
    return 1
  }

  if (
    authenticationMethodSortPriority.indexOf(sessionA.authenticationMethod) < authenticationMethodSortPriority.indexOf(sessionB.authenticationMethod)
  ) {
    return -1
  }

  if (sessionA.rfid && sessionB.rfid) {
    return sessionA.rfid.localeCompare(sessionB.rfid)
  }

  if (sessionA.rfid && !sessionB.rfid) {
    return -1
  }

  if (!sessionA.rfid && sessionB.rfid) {
    return 1
  }

  return 0
}
